import pro1 from "../components/assets/project1.jpeg"
import pro2 from "../components/assets/project2.jpeg"
import pro3 from "../components/assets/project3.jpeg"
import pro4 from "../components/assets/project4.png"


const ProjectCardData = [
    {
       imgsrc:pro1,
       title:"Event Management",
       text:"Thriving Facebook community and top-ranked podcast, amy inspires a grounded, tangible and self-affirmi sense of wow really can do this  for over 100,000 online enrepreneur,Best-selling marketingCourses",
       view:"https://event-management-mern-client.vercel.app/",
       source:"https://github.com/Saurabhjaiswar05/EventManagment"
    },
    {
        imgsrc:pro2,
        title:"MERN_E-COMMERCE",
        text:"Thriving Facebook community and top-ranked podcast, amy inspires a grounded, tangible and self-affirmi sense of wow really can do this  for over 100,000 online enrepreneur,Best-selling marketingCourses",
        view:"https://mern-e-commerce-client-git-main-saurabhjaiswar05s-projects.vercel.app/",
        source:"https://github.com/Saurabhjaiswar05/MERN_E-COMMERCE_CLIENT"
     },
    {
        imgsrc:pro3,
        title:"Elegance Software",
        text:"Elegance Softwares is a professional web development and design initiative that focuses on delivering responsive, dynamic, and user-friendly solutions to help businesses thrive in the digital world.",
        view:"https://elegance-software-mu.vercel.app/",
        source:"https://github.com/Saurabhjaiswar05/EleganceSoftware"
     },
    {
        imgsrc:pro4,
        title:"Elegance Real Estate",
        text:"Elegance Real Estate offers a sleek platform for buying, selling, and renting premium properties with ease and expert guidance.",
        view:"https://elegancerealestate.netlify.app/",
        source:"https://github.com/Saurabhjaiswar05/Real-Estate"
     }
]

export default ProjectCardData
